import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { PublisherError, ComponentType } from 'social/publisher/Publisher.types';

import 'social/publisher/error-display/ErrorDisplay.scss';

interface Props {
    publisherErrors: PublisherError[];
    component: ComponentType;
    source?: string;
}

export const ErrorDisplay: FunctionComponent<Props> = ({ publisherErrors, component, source }) => {
    const { t } = useTranslation(['social/publisher']);
    const displayCSS = classnames('r4e-social-error-display');

    const errors: PublisherError[] = publisherErrors.filter((err) => {
        if (source) {
            return err.component === component && err.source === source;
        }
        return err.component === component;
    });

    // Prevents display the same error messages for the same component when multiple sources are selected
    const errorMessages: string[] = _.uniq(_.map(errors, 'message'));

    const errorsEl: JSX.Element[] = errorMessages.map((message) => {
        return (
            <li className="error-display-message" key={message}>
                {t(message)}
            </li>
        );
    });

    if (errorMessages.length > 0) {
        return (
            <div className={displayCSS}>
                <div className="error-display-icon">
                    <i className="icon-exclamation-circle" />
                </div>
                <ul className="error-display-messages">{errorsEl}</ul>
            </div>
        );
    }

    return <></>;
};
